import React, { useState } from 'react';

import { Modal, Body, Footer, FooterButton } from './modalElements';
import { getConfig } from 'functions/getConfig';

export default React.memo(({ acceptFunction }) => {
  const [isOpen, setIsOpen] = useState(true);
  const confirmModal = (value) => {
    setIsOpen(false);
    return acceptFunction(value);
  };

  return (
    <Modal isOpen={isOpen && !window.location.pathname.includes('/privacy-policy')}>
      <Body>
        <p>
          We use cookies to improve your experience on our website. For more information read our{' '}
          <a href={`${getConfig().REACT_URL}/cookies`} target="_blank" rel="noopener noreferrer">
            cookie table
          </a>
          .
        </p>
      </Body>
      <Footer>
        <FooterButton label="Accept only necessary cookies" onClick={() => confirmModal('necessary')} />
        <FooterButton label="Accept all cookies" onClick={() => confirmModal('all')} />
      </Footer>
    </Modal>
  );
});
